import React from 'react';

// Utils
import { MESSAGES } from '~/utils/message';
import { handlePhoneNumberChange } from '~/utils/helperFunctions';

// Components
import MultiSelect from '~/components/General/MultiSelectNew';

// Mui Components
import { Input, InputLabel, Box, Chip } from '@mui/material';
import Typography from '@mui/material/Typography';
import { InputAdornment } from '@mui/material';

// Icons
import HighlightOffIcon from '@mui/icons-material/HighlightOffOutlined';

// Styles
import './styles.scss';

const labelStyles = {
  fontFamily: 'Inter !important',
  fontSize: '16px !important',
  fontWeight: '500 !important',
  lineHeight: '19px !important',
  letterSpacing: '0em !important',
  textAlign: 'left !important',
};

const ModalInput = (props) => {
  const {
    label,
    type,
    isMultiSelect = false,
    options = [],
    value,
    setValue,
    name,
    realTimeValidation,
    formik,
    isCreate,
    placeholder,
    endAdornment,
  } = props;

  const removeTag = (tag) => {
    setValue((selectedTags) =>
      selectedTags.filter((item) => {
        return item !== tag;
      })
    );
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    if (name === 'phoneNo') {
      handlePhoneNumberChange(inputValue, formik.setFieldValue, name);
    } else {
      formik.setFieldValue(name, inputValue);
    }
  };

  return (
    <Box
      className="createContactInput"
      sx={{
        width: '100%',
        maxWidth: '100%',
        '@media (max-width:600px)': {
          maxWidth: 'none',
        },
      }}
    >
      <InputLabel className="modalLabel" sx={labelStyles}>
        {label}
      </InputLabel>
      {!isMultiSelect ? (
        <Input
          type={type}
          placeholder={placeholder || label}
          className={
            formik.errors[name] && formik.touched[name]
              ? 'modalInputField invalid'
              : 'modalInputField'
          }
          sx={{
            width: isCreate && '100% !important',
            maxWidth: isCreate && '100% !important',
          }}
          onBlur={realTimeValidation ? formik.handleBlur(name) : undefined}
          onKeyDown={realTimeValidation ? formik.handleBlur(name) : undefined}
          value={value}
          onChange={handleInputChange}
          endAdornment={endAdornment}
        />
      ) : (
        <>
          <MultiSelect
            component={'tag-create-contact'}
            options={options}
            noOptionText={MESSAGES.CONTACTS.ADVANCE_FILTERS.NO_SEARCH_TAG}
            selectedValue={value}
            setSelectedValue={setValue}
            placeHolderText={MESSAGES.CONTACTS.CREATE.CREATE_SEARCH_TAGS_PLACEHOLDER_NEW}
            newDesign={true}
            clearable={true}
          />
        </>
      )}
      {formik?.touched[name] && formik?.errors[name] ? (
        <Typography className="errorMessage">{formik.errors[name]}</Typography>
      ) : null}
    </Box>
  );
};

export default ModalInput;
